import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogTitle,
} from '@radix-ui/react-dialog'
import { Loader2 } from 'lucide-react'
import React from 'react'

interface WaitDialogProps {
  isOpen: boolean
  onDismiss?: () => void
  status: string
  progress?: number
}

const WaitDialog: React.FC<WaitDialogProps> = ({ isOpen, onDismiss, status, progress }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onDismiss}>
      <DialogOverlay className="fixed inset-0 items-end justify-center bg-gray-500 bg-opacity-75 p-4 text-center sm:items-center sm:p-0" />
      <DialogContent className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
        <DialogTitle className="sr-only">{status}</DialogTitle>
        <DialogDescription className="sr-only">Please wait while we process your request</DialogDescription>
        <div className="flex flex-col items-center justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary bg-opacity-25">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
          <p className="mt-4">
            <span className="text-base font-semibold leading-6 text-gray-900">{status}</span>
          </p>
          {progress !== undefined && (
            <div className="mt-4 w-full">
              <div className="h-2.5 w-full rounded-full bg-gray-200">
                <div
                  className="h-2.5 rounded-full bg-green-500 transition-all duration-300"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          )}
        </div>
        {onDismiss && (
          <DialogClose asChild>
            <button className="cursor-pointer border-none bg-transparent text-lg" onClick={onDismiss}>
              Close
            </button>
          </DialogClose>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default WaitDialog
